import { render } from "./Instillation.vue?vue&type=template&id=d6eb4e64&scoped=true"
import script from "./Instillation.vue?vue&type=script&lang=js"
export * from "./Instillation.vue?vue&type=script&lang=js"

import "./Instillation.vue?vue&type=style&index=0&id=d6eb4e64&lang=scss&scoped=true"

import exportComponent from "E:\\aaes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6eb4e64"]])

export default __exports__